import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from 'carbon-react/lib/components/box/box.component';
import Typography from 'carbon-react/lib/components/typography';

import headerPattern from './dashboard-header-pattern.png';

export interface DashboardHeaderProps {
  firstName: string;
}

export const DashboardHeader = ({ firstName }: DashboardHeaderProps) => {
  return (
    <Box backgroundColor="#000" height="120px" display="flex">
      <Box p="30px">
        <Typography fontSize="30px" fontWeight="700" color="#fff" mb={0} lineHeight="125%">
          <FormattedMessage id="onboarding.hello" defaultMessage="Hello, {firstName}!" values={{ firstName }} />
        </Typography>
        <Typography color="#fff" fontSize="12px" fontWeight="500" lineHeight="150%">
          <FormattedMessage id="onboarding.welcome_futrli_overview" defaultMessage="Welcome to your Futrli overview" />
        </Typography>
      </Box>
      <img src={headerPattern} style={{ marginLeft: 'auto' }} alt="dashboard-header" />
    </Box>
  );
};
